import React from 'react';
import { Megaphone, Smartphone, Sparkles, Zap, Gift, Star } from 'lucide-react';
import { PLAY_STORE_URL } from './AppDownloadPopup';

const ANNOUNCEMENTS = [
  { icon: Megaphone, text: 'KoPartner App Is Now Live — Download Today!' },
  { icon: Smartphone, text: 'Available on Google Play — Install the app for faster booking' },
  { icon: Sparkles, text: 'Get instant notifications — Scan the QR or open Google Play' },
  { icon: Zap, text: 'Book partners easily on mobile — The app is live now' },
  { icon: Gift, text: 'Download the app and unlock exclusive offers' },
  { icon: Star, text: "India's #1 platform — Now on mobile app too" },
];

const AnnouncementBar = () => {
  const items = [...ANNOUNCEMENTS, ...ANNOUNCEMENTS];

  return (
    <div
      className="bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 text-white border-b border-purple-200/40 overflow-hidden"
      data-testid="announcement-bar"
    >
      <div className="announcement-marquee flex items-center h-9">
        <div className="announcement-track flex items-center gap-10 whitespace-nowrap">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <a
                key={`${item.text}-${index}`}
                href={PLAY_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 text-[11px] sm:text-xs font-semibold uppercase tracking-wide hover:text-yellow-200 transition-colors shrink-0"
              >
                <Icon size={14} className="text-yellow-300 shrink-0" />
                <span>{item.text}</span>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
